var _path, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconHealth = function SvgIconHealth(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.41,
    clipRule: "evenodd",
    viewBox: "0 0 48 48",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h48v48H0z"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-2620084581__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-2620084581__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48 8a8 8 0 0 0-8-8H8a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b7c2c1",
    d: "M26 38s.03-23.4 0-28.08c-.08-3.86-4.5-7.02-8.27-5.48A6.13 6.13 0 0 0 14 10.01V16c-.04 1.15-.36 1.24-.74 1.55-1.16.95-3.2.2-3.26-1.55v-6A10.26 10.26 0 0 1 20.13 0c5.2.1 9.84 4.62 9.87 10 0 0-.02 25.3 0 28.08.07 3.86 4.5 7.02 8.27 5.48A6.14 6.14 0 0 0 42 37.99V27c.05-1.55.6-1.59 1.25-1.85 1.16-.47 2.67.42 2.75 1.73V38c-.03 5.4-4.95 10.2-10.39 10-5.07-.2-9.58-4.7-9.61-10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b7c2c1",
    d: "M28.38 41H16v7h17.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b7c2c1",
    d: "M8 48a4 4 0 0 1-4-4V27a10 10 0 1 1 20 0v17a4 4 0 0 1-4 4h-2a2 2 0 1 1 0-4 2 2 0 0 0 2-2V27a6 6 0 0 0-12 0v15a2 2 0 0 0 2 2 2 2 0 1 1 0 4zm40-24h-6l-1 17-7.62 7H40a8 8 0 0 0 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f45356",
    d: "M7 20a4 4 0 0 1 4-4h3a2 2 0 0 0 2-2v-3a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v3a2 2 0 0 0 2 2h3a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-3a2 2 0 0 0-2 2v3a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4v-3a2 2 0 0 0-2-2h-3a4 4 0 0 1-4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc4857",
    d: "M7 19.86A10 10 0 0 1 24 27v14h-4V27a6 6 0 0 0-12 0v3.65C7.38 29.95 7 29 7 28v-8.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc4857",
    d: "M20 32.5h6V41h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6567",
    d: "m19.77 17.09 1.06-1.07a2.5 2.5 0 0 0-3.54-3.54l-1.29.83V11a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v3a2 2 0 0 0 2 2h3a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-2.31a1.09 1.09 0 0 1 0-1.54l.29-.3a2.5 2.5 0 0 0 0-3.53 2.5 2.5 0 0 0-3.54 0l-1.06 1.06-1.06 1.06a2.5 2.5 0 0 1-3.54 0 2.5 2.5 0 0 1 0-3.53l2.12-2.12a2.5 2.5 0 0 0 0-3.54 2.5 2.5 0 0 0-1.76-.73c-.67 0-2.86 1.82-2.86 1.82a2.46 2.46 0 0 1-3.48 0 2.54 2.54 0 0 1-.03-3.56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc4857",
    d: "M27 7h1c.73 0 1.41.2 2 .54v32.92c-.59.35-1.27.54-2 .54h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b557b",
    d: "M8 46a2 2 0 0 0-2-2H4v4h2a2 2 0 0 0 2-2m4 0c0 1.1.9 2 2 2h2v-4h-2a2 2 0 0 0-2 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8dee4",
    d: "M4 48a4 4 0 0 1-4-4V27a10 10 0 1 1 20 0v17a4 4 0 0 1-4 4V27a6 6 0 0 0-12 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 31.75a2 2 0 1 0-4 0v2a2 2 0 1 0 4 0zM4 28a2 2 0 0 0-2-2 2 2 0 0 0-2 2v9.5a2 2 0 0 0 2 2 2 2 0 0 0 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d5868",
    d: "M14 16.5c0-.83-.67-1.5-1.5-1.5h-5a1.5 1.5 0 1 0 0 3h5c.83 0 1.5-.67 1.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d5868",
    d: "M24 38s.03-23.4 0-28.08c-.08-3.86-4.5-7.02-8.27-5.48A6.13 6.13 0 0 0 12 10.01V16c-.04 1.15-.36 1.24-.74 1.55-1.16.95-3.2.2-3.26-1.55v-6A10.26 10.26 0 0 1 18.13 0c5.2.1 9.84 4.62 9.87 10 0 0-.02 25.3 0 28.08.07 3.86 4.5 7.02 8.27 5.48A6.14 6.14 0 0 0 40 37.99V27c.05-1.55.6-1.59 1.25-1.85 1.16-.47 2.67.42 2.75 1.73V38c-.03 5.4-4.95 10.2-10.39 10-5.07-.2-9.58-4.7-9.61-10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363e58",
    d: "M28 22a2 2 0 1 0-4 0v8a2 2 0 1 0 4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52708b",
    d: "M28 13a2 2 0 1 0-4 0v2a2 2 0 1 0 4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#76abbf",
    d: "m44.5 20.5-9.5-2v10l9.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8dee4",
    d: "m38.5 19.24 4 .84v1.42a2 2 0 0 1-4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363e58",
    d: "M44 26a2 2 0 0 0-2-2 2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 2 2 0 0 0 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52708b",
    d: "M44 32a2 2 0 0 0-2-2 2 2 0 0 0-2 2v1a2 2 0 0 0 2 2 2 2 0 0 0 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#89bfc9",
    d: "M37 17.96A1.96 1.96 0 0 0 35.04 16c-1.13 0-2.04.91-2.04 2.04V29a2 2 0 1 0 4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8dee4",
    d: "M37 18a2 2 0 0 0-4 0v6a2 2 0 0 0 4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#76abbf",
    d: "M48 21a2 2 0 0 0-4 0v5a2 2 0 0 0 4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8dee4",
    d: "M48 21a2 2 0 0 0-4 0v1a2 2 0 0 0 4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363e58",
    d: "M12 10.5a2 2 0 0 0-2 2v.5c0 1.1.9 2 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52708b",
    d: "M14 16.5a1.5 1.5 0 0 0-1.5-1.5h-1a1.5 1.5 0 0 0-1.5 1.5 1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52708b",
    fillRule: "nonzero",
    d: "M16.1.26c1.88.13 2.8 3.23.16 4a6.24 6.24 0 0 0-3.98 3.93s-.35.82-1.07 1.14c-1.42.63-3.26-.84-2.66-2.6A10.18 10.18 0 0 1 15.5.33s.16-.08.6-.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37 18a2 2 0 0 0-4 0v2.37a2 2 0 1 0 4 0z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconHealth);
export default ForwardRef;